import React from "react";
import {Link, TableColumn} from "@backstage/core-components";
import {CatalogTableRow} from "@backstage/plugin-catalog";
import SchemaEntityPage, {
  createSchemaEntityTableLinksColumn,
  getSchemaEntityTableColumns
} from "../schema/common/SchemaEntityPage";
import {API_CONFIG} from "../schema/common/types";

export const createApiTableLinksColumn = (width?: string): TableColumn<CatalogTableRow> =>
  createSchemaEntityTableLinksColumn(API_CONFIG, width);

export const getApiTableColumns = (): TableColumn<CatalogTableRow>[] =>
  getSchemaEntityTableColumns(API_CONFIG);

export const ApiTableSubtitle = () => {
  return (
    <>The list of APIs comes from the <Link
      to="https://github.com/weave-lab/schema">schema</Link> repository
      under the apis/ directory. These are public-facing APIs following Google AIP standards.</>
  );
};

const ApiPage = () => <SchemaEntityPage config={API_CONFIG}/>;

export default ApiPage;
